import React, { Component } from 'react';
import PropTypes from 'prop-types';

export class Redirect extends Component {
	constructor(props){
		super(props);
		this.state = {}
	}
	componentDidMount(){
		window.location = this.props.location;
	}

	render() {
		return (
			<div>
				Loading...
			</div>
		)
	}
};

Redirect.propTypes = {
	location: PropTypes.string
}

export class CoffeeOutside extends Component {
	render(){
		return <Redirect location="http://dangercode.net/coffee_outside/" />
	}
}



// WEBPACK FOOTER //
// ./src/Redirect.js